import { ALL_LANGUAGES_TYPE } from './constants'
import _ from 'lodash'

// FIXME @deprecated
export const DEPRECATED_TO_BCP47 = {
    'ar-ar': 'ar',    // was used in this assessment
    'be-fr': 'fr-be', // used in TalentWeb
    'be-nl': 'nl-be', // used in TalentWeb
    'be-en': 'en-be', // used in TalentWeb
    'en-uk': 'en-gb', // used in TalentWeb
    'en-en': 'en-us', // used in TalentWeb
    'br-pt': 'pt-br', // used in TalentWeb
    'fr-qc': 'fr-ca', // used in TalentWeb
    'qc-fr': 'fr-ca', // was used in this assessment
} satisfies Record<string, ALL_LANGUAGES_TYPE>;
export type DEPRECATED_KEYS = keyof typeof DEPRECATED_TO_BCP47;
export type DEPRECATED_VALUES = typeof DEPRECATED_TO_BCP47[DEPRECATED_KEYS];

// Cf. Northstar-TalentWeb/src/constants/languages.ts
export const NORTHSTAR_SUPPORTED_LANGS = [
    'de-de',
    'en-gb',
    'es-es',
    'fr-fr',
    'it-it',
    'hu-hu',
    'nl-nl',
    'pl-pl',
    'pt-pt',
    'ro-ro',
    'tr-tr',
] satisfies ALL_LANGUAGES_TYPE[];
export type NORTHSTAR_SUPPORTED_LANGS_TYPE = (typeof NORTHSTAR_SUPPORTED_LANGS)[number];

// Cf. PHP
export const LEGACY_SUPPORTED_LANGS  = [
    'en-en',
    'be-nl', // @deprecated
    'be-fr', // @deprecated
    'pl-pl',
    'de-de',
    'es-es',
    'it-it',
    'br-pt', // @deprecated
    'tr-tr',
    'hu-hu',
    'nl-nl',
    'ro-ro',
    'ar-ae',
    'ar-sa'
] satisfies (DEPRECATED_KEYS | ALL_LANGUAGES_TYPE)[];
export type LEGACY_SUPPORTED_LANGS_TYPE = (typeof LEGACY_SUPPORTED_LANGS)[number];
export type LEGACY_OUTLIER = Exclude<LEGACY_SUPPORTED_LANGS_TYPE, ALL_LANGUAGES_TYPE>;
export type MISSING_BCP_47 = Exclude<ALL_LANGUAGES_TYPE, LEGACY_SUPPORTED_LANGS_TYPE>;


export const BCP47_TO_LEGACY: Record<DEPRECATED_VALUES | MISSING_BCP_47, LEGACY_SUPPORTED_LANGS_TYPE > = {
    // fr
    'fr-be': 'be-fr',
    'fr-ca': 'be-fr',
    'fr-fr': 'be-fr',
    // en
    'en-us': 'en-en',
    'en-gb': 'en-en',
    'en-be': 'en-en',
    // nl
    'nl-be': 'nl-nl',
    // pt
    'pt-br': 'br-pt',
    'pt-pt': 'br-pt',
    // arabic
    'ar': 'ar-ae',
    'ar-ma': 'ar-ae',
    'ar-eg': 'ar-ae',
    'ar-dz': 'ar-ae',
    'ar-iq': 'ar-ae',
    'ar-jo': 'ar-ae',
    'ar-lb': 'ar-ae',
    'ar-ly': 'ar-ae',
    'ar-om': 'ar-ae',
    'ar-qa': 'ar-ae'
}

// @deprecated
export const fromBCP47toLegacy = (lang: ALL_LANGUAGES_TYPE) => lang in BCP47_TO_LEGACY ? BCP47_TO_LEGACY[lang as DEPRECATED_VALUES | MISSING_BCP_47] : lang;